import React from 'react'
import { Table } from 'reactstrap'
import Card from 'src/components/Card'
import { useReportBuilderContext } from '../ReportBuilderContext'

const ROWS = 8

const LoadingTable: React.FC = () => {
  const { selectedFields } = useReportBuilderContext()
  return (
    <Card title='Results'>
      <Table>
        <thead>
          <tr>
            {selectedFields.map(f => <th key={f.name}>{f.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: ROWS }).map((_, i) => (
            <tr key={i}>
              {selectedFields.map(f => (
                <td key={f.name}>
                  <p className='placeholder-glow mb-0'>
                    <span className='placeholder col-12' />
                  </p>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  )
}

export default LoadingTable
